<template>
  <div class="section-white">
    <h3 class="title">退换货详情</h3>
    <div class="section-header with-border">
      <h3>退换货信息</h3>
    </div>
    <div class="section-body">
      <el-row>
        <el-col :span="3" class="col-3 content-right">退换货编号:</el-col>
        <el-col :span="20">{{aftersalesInfo.aftersales_bn}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">申请时间:</el-col>
        <el-col :span="20">{{aftersalesInfo.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">申请处理进度:</el-col>
        <el-col :span="20">
          <span v-if="aftersalesInfo.progress == '0'"> 等待商家处理</span>
          <span v-else-if="aftersalesInfo.progress == '1'">商家接受申请，等待消费者回寄</span>
          <span v-else-if="aftersalesInfo.progress == '2'">消费者回寄，等待商家收货确认</span>
          <span v-else-if="aftersalesInfo.progress == '3'">售后已驳回</span>
          <span v-else-if="aftersalesInfo.progress == '4'">售后已处理</span>
          <span v-else-if="aftersalesInfo.progress == '5'">退款驳回</span>
          <span v-else-if="aftersalesInfo.progress == '6'">退款已处理</span>
          <span v-else-if="aftersalesInfo.progress == '7'">售后关闭</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">退换货类型:</el-col>
        <el-col :span="20">
          <span v-if="aftersalesInfo.aftersales_type == 'ONLY_REFUND'">仅退款 </span>
          <span v-if="aftersalesInfo.aftersales_type == 'REFUND_GOODS'">退货退款 </span>
          <span v-if="aftersalesInfo.aftersales_type == 'EXCHANGING_GOODS'">换货 </span>
        </el-col>
      </el-row>
    </div>

    <div class="section-header with-border">
      <h3>订单信息</h3>
    </div>
    <div class="section-body">
      <el-row>
        <el-col :span="3" class="col-3 content-right">订单编号:</el-col>
        <el-col :span="20">{{orderInfo.order_id}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">商家名称:</el-col>
        <el-col :span="20">{{orderInfo.receiver_name}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">订单状态:</el-col>
        <el-col :span="20">
          <span v-if="orderInfo.order_status=='DONE'">订单完成</span>
          <span v-if="orderInfo.order_status=='NOTPAY'">未支付</span>
          <span v-if="orderInfo.order_status=='PAYED'">已支付</span>
          <span v-if="orderInfo.order_status=='CANCEL'">已取消</span>
          <span v-if="orderInfo.order_status=='WAIT_BUYER_CONFIRM'">待用户收货</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">会员信息:</el-col>
        <el-col :span="20">{{orderInfo.mobile}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">下单时间:</el-col>
        <el-col :span="20">{{orderInfo.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">收货信息:</el-col>
        <el-col :span="20">{{orderInfo.receiver_state}}{{orderInfo.receiver_city}}{{orderInfo.receiver_district}}{{orderInfo.receiver_address}}</el-col>
      </el-row>
    </div>

    <div class="section-header with-border">
      <h3>退换货商品信息</h3>
    </div>
    <div class="section-body">
      <el-row>
        <template>
          <el-table
            :data="orderInfo.items"
            style="width: 100%">
            <el-table-column
              class="goods-img"
              prop="pic"
              label="商品图片"
              width="180">
              <template slot-scope="scope">
                <span><img :src="wximageurl + scope.row.pic" :alt="scope.row.item_name" /></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="item_name"
              label="商品名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="item_spec_desc"
              label="规格"
              width="180">
            </el-table-column>
            <el-table-column
              prop="num"
              label="数量"
              width="180">
            </el-table-column>
            <el-table-column v-if="'point' != tradeInfo.payType"  label="总价(元)">
              <template slot-scope="scope">
                <span>￥{{scope.row.total_fee / 100}}</span>
              </template>
            </el-table-column>
            <el-table-column v-else  label="总价(积分)">
              <template slot-scope="scope">
                <span>{{scope.row.point}}</span>
              </template>
            </el-table-column>
            <template v-if="orderInfo.delivery_status == 'DONE' && !orderInfo.delivery_corp">
              <el-table-column  label="发货状态">
                <template slot-scope="scope">
                <span>已发货</span>
                </template>
              </el-table-column>
              <el-table-column  label="快递公司">
                <template slot-scope="scope">
                  <span>{{dlycorpskn[scope.row.delivery_corp]}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="快递单号">
                <template slot-scope="scope">
                  <span>{{scope.row.delivery_code}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </template>
      </el-row>
    </div>

    <div class="section-header with-border">
      <h3>售后申请信息</h3>
    </div>
    <div class="section-body">
      <el-row>
        <el-col :span="3" class="col-3 content-right">退货理由:</el-col>
        <el-col :span="20">{{aftersalesInfo.reason}}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="col-3 content-right">问题描述:</el-col>
        <el-col :span="20">{{aftersalesInfo.description}}</el-col>
      </el-row>
      <el-row v-if="aftersalesInfo.evidence_pic">
        <el-col :span="3" class="col-3 content-right">图片信息:</el-col>
        <el-col :span="20">
          <ul v-if="aftersalesInfo.evidence_pic[0]">
            <li v-for="(pic, index) in aftersalesInfo.evidence_pic" :key="index" class="artical-item">
              <img :src="wximageurl + pic" width="40" height="40"/>
            </li>
          </ul>
          <span v-else>无图片信息</span>
        </el-col>
      </el-row>
    </div>

    <template v-if="aftersalesInfo.progress != '0'">
      <div class="section-header with-border">
        <h3>审核结果</h3>
      </div>
      <div class="section-body">
        <el-row>
          <el-col :span="3" class="col-3 content-right">审核状态:</el-col>
          <el-col :span="20">
            <span v-if="aftersalesInfo.progress == '1'">商家接受申请，等待消费者回寄</span>
            <span v-else-if="aftersalesInfo.progress == '2'">消费者回寄，等待商家收货确认</span>
            <span v-else-if="aftersalesInfo.progress == '3'">售后已驳回</span>
            <span v-else-if="aftersalesInfo.progress == '4'">售后已处理</span>
            <span v-else-if="aftersalesInfo.progress == '5'">退款驳回</span>
            <span v-else-if="aftersalesInfo.progress == '6'">退款已处理</span>
            <span v-else-if="aftersalesInfo.progress == '7'">售后关闭</span>
          </el-col>
        </el-row>
        <el-row v-if="aftersalesInfo.memo">
          <el-col :span="3" class="col-3 content-right">备注:</el-col>
          <el-col :span="20">{{aftersalesInfo.memo}}</el-col>
        </el-row>
        <el-row v-if="aftersalesInfo.refuse_reason">
          <el-col :span="3" class="col-3 content-right">商家处理申请说明:</el-col>
          <el-col :span="20">{{aftersalesInfo.refuse_reason}}</el-col>
        </el-row>
      </div>
    </template>

    <!-- 退款信息展示 -->
    <template v-if="refundInfo.refund_fee">
      <div class="section-header with-border">
        <h3>退款处理</h3>
      </div>
      <div class="section-body">
        <el-row>
          <el-col :span="3" class="col-3 content-right">退款金额:</el-col>
          <el-col :span="20">{{refundInfo.refund_fee}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="col-3 content-right">退款状态:</el-col>
          <el-col :span="20">
            <span v-if="refundInfo.refund_status == 'SUCCESS'">
              退款成功
            </span>
            <span v-else-if="refundInfo.refund_status == 'REFUNDCLOSE'">
              退款关闭。
            </span>
            <span v-else-if="refundInfo.refund_status == 'PROCESSING'">
              退款处理中
            </span>
            <span v-else-if="refundInfo.refund_status == 'CHANGE'">
              退款异常
            </span>
          </el-col>
        </el-row>
        <el-row v-if="refundInfo.refunds_memo">
          <el-col :span="3" class="col-3 content-right">退款备注:</el-col>
          <el-col :span="20">{{refundInfo.refunds_memo}}</el-col>
        </el-row>
      </div>
    </template>

    <!-- 商家发货信息 -->
    <template v-if="aftersalesInfo.aftersales_type=='EXCHANGING_GOODS' && aftersalesInfo.progress=='4'">
      <div class="section-header with-border">
        <h3>商家发货物流信息</h3>
      </div>
      <div class="section-body">
        <el-row>
          <el-col :span="3" class="col-3 content-right">买家收货信息:</el-col>
          <el-col :span="20">{{aftersalesInfo.aftersales_bn}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="col-3 content-right">物流公司:</el-col>
          <el-col :span="20">{{aftersalesInfo.aftersales_bn}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="col-3 content-right">物流单号:</el-col>
          <el-col :span="20">{{aftersalesInfo.aftersales_bn}}</el-col>
        </el-row>
      </div>
    </template>

    <!-- 用户退换货物流信息 -->
    <template v-if="aftersalesInfo.sendback_data">
      <div class="section-header with-border">
        <h3>用户退换货物流信息</h3>
      </div>
      <div class="section-body">
        <el-row>
          <el-col :span="3" class="col-3 content-right">物流公司:</el-col>
          <el-col :span="20">{{dlycorpskn[aftersalesInfo.sendback_data.corp_code]}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="col-3 content-right">物流单号:</el-col>
          <el-col :span="20">{{aftersalesInfo.sendback_data.logi_no}}</el-col>
        </el-row>
      </div>
    </template>

    <!-- 换货商家发货信息 -->
    <template v-if="aftersalesInfo.sendconfirm_data">
      <div class="section-header with-border">
        <h3>商家发货物流信息</h3>
      </div>
      <div class="section-body">
        <el-row>
          <el-col :span="3" class="col-3 content-right">物流公司:</el-col>
          <el-col :span="20">{{dlycorpskn[aftersalesInfo.sendconfirm_data.corp_code]}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="col-3 content-right">物流单号:</el-col>
          <el-col :span="20">{{aftersalesInfo.sendconfirm_data.logi_no}}</el-col>
        </el-row>
      </div>
    </template>

    <!-- 申请通过 -->
    <template v-if="aftersalesInfo.progress=='1' || aftersalesInfo.progress=='2'">
      <!-- 换货商家发货信息填写 -->
      <template v-if="aftersalesInfo.aftersales_type =='EXCHANGING_GOODS'">
        <div class="section-header with-border">
          <h3>商家发货物流</h3>
        </div>
        <div>
          <el-row class="agreen-info">
            <el-col :span="2" class="col-3 agreen-right">物流公司:</el-col>
            <el-col :span="8">
              <el-input
                v-model="corp_code"
                type="text"
                placeholder="请输入物流公司"
                clearable>
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2" class="col-3 agreen-right">物流单号:</el-col>
            <el-col :span="8">
              <el-input
                v-model="logi_no"
                type="text"
                placeholder="请输入物流单号"
                clearable>
              </el-input>
            </el-col>
          </el-row>
        </div>
        <div class="section-footer with-border content-center">
          <el-button type="primary" @click="sendBackAction">确认发货</el-button>
        </div>
      </template>

      <!-- 退货退款审核 -->
      <template v-else-if="aftersalesInfo.aftersales_type =='REFUND_GOODS'">
        <div class="section-header with-border">
          <h3>商家处理信息</h3>
        </div>
        <div class="section-body">
          <template>
            <el-row>
              <el-col :span="3" class="col-3 content-right">处理结果:</el-col>
              <el-col :span="20">
              <template v-if="IsBind">
                <el-radio v-model="check_refund" label="0" disabled >不同意</el-radio>
                <el-radio v-model="check_refund" label="1" disabled>同意</el-radio>
              </template>
              <template v-else>
                <el-radio v-model="check_refund" label="0" >不同意</el-radio>
                <el-radio v-model="check_refund" label="1" >同意</el-radio>
              </template>
              </el-col>
            </el-row>
            <template v-if="aftersalesInfo.aftersales_type !='EXCHANGING_GOODS' && check_refund=='1'">
              <el-row>
                <el-col :span="3" class="col-3 content-right">退款金额:</el-col>
                <el-col :span="8">
                  <el-input type="number" v-model="refund_fee" min="0" :max="orderInfo.total_fee/100" step='0.1'></el-input>
                </el-col>
              </el-row>
            </template>
            <el-row v-if="this.check_refund=='0'">
              <el-col :span="2" class="col-3 agreen-right">拒绝原因:</el-col>
              <el-col :span="12">
                <el-input type="textarea" v-model="refuse_reason" :rows="3" placeholder="请输入拒绝原因"></el-input>
              </el-col>
            </el-row>
            <div class="section-footer with-border content-center">
              <el-button type="primary" @click="refundAction" v-if="IsBind" disabled>确认</el-button>
              <el-button type="primary" @click="refundAction" v-else>确认</el-button>

            </div>
          </template>
        </div>
      </template>
    </template>

    <template  v-if="aftersalesInfo.progress =='0'">
      <div class="section-header with-border">
        <h3>商家处理信息</h3>
      </div>
      <div class="section-body">
        <template>
          <el-row>
            <el-col :span="3" class="col-3 content-right">处理结果:</el-col>
            <el-col :span="20">
              <template v-if="IsBind">
                <el-radio v-model="is_approved" label="0" disabled >不同意</el-radio>
                <el-radio v-model="is_approved" label="1" disabled>同意</el-radio>
              </template>
               <template v-else>
                <el-radio v-model="is_approved" label="0" >不同意</el-radio>
                <el-radio v-model="is_approved" label="1">同意</el-radio>
              </template>
            </el-col>
          </el-row>
          <template v-if="aftersalesInfo.aftersales_type=='ONLY_REFUND' && is_approved=='1'">
            <el-row v-if="'point' != tradeInfo.payType">
              <el-col :span="3"  class="col-3 content-right">退款金额:</el-col>
              <el-col :span="8">
                <el-input type="number" v-model="refund_fee" min="0" :max="orderInfo.total_fee/100"></el-input>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="3"  class="col-3 content-right">退款积分:</el-col>
              <el-col :span="8">
                <el-input type="number" v-model="refund_point" min="0" :max="orderInfo.point"></el-input>
              </el-col>
            </el-row>
          </template>
          <el-row v-if="this.is_approved=='0'">
            <el-col :span="2" class="col-3 agreen-right">拒绝原因:</el-col>
            <el-col :span="12">
              <el-input type="textarea" v-model="refuse_reason" :rows="3" placeholder="请输入拒绝原因"></el-input>
            </el-col>
          </el-row>
          <div class="section-footer with-border content-center">
            <el-button type="primary" @click="reviewSubmit" v-if="IsBind" disabled>提交审核</el-button>
             <el-button type="primary" @click="reviewSubmit" v-else>提交审核</el-button>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss" type="text/css">
  h3.title {
    padding: 20px;
    font-size: 18px;
    color: #ff5000;
  }
  .col-3 {
    width: 120px;
    margin-right: 10px;
  }
  .detail-info {
    margin: 0 10px;
  }
  .el-row {
    margin-bottom: 10px;
  }
  img {
    max-width: 100px;
    margin: 0 auto;
  }
  .agreen-info {
    margin-top: 20px;
  }
  .agreen-right {
    line-height: 40px;
    text-align: right;
  }
</style>
<script>
  import { getAftersalesDetail,reviewAftersales,refundCheck,sendConfirm } from '../../../api/aftersales'
  import { isBind } from '../../../api/trade'
  import hqbdlycorp_kname from '../../../common/hqbdlycorp_kname.json'
  export default {
    data () {
      return {
        aftersales_bn: '',
        aftersalesInfo: {},
        refundInfo: {},
        orderInfo: {},
        distributorInfo: {},
        radio: '1',
        agreen: false,
        loading: false,
        IsBind:false,
        order_id: '',
        tradeInfo: {},
        resource: '',
        user_id: 0,
        memberInfo: {
          gradeInfo: {}
        },
        dlycorpskn: hqbdlycorp_kname,
        is_approved: "0",
        check_refund: "0",
        refuse_reason: "",
        refund_fee: 0,
        refund_point: 0,
        corp_code: '', // 物流公司
        logi_no: '', // 快递单号
        reviewData: {},
        refundData: {},
        exchangeSendBack: {}
      }
    },
    methods: {
      aftersaleInfo() {
        getAftersalesDetail(this.aftersales_bn).then(response => {
          let data = response.data.data
          this.aftersalesInfo = data.aftersales
          this.orderInfo = data.orderInfo
          this.distributorInfo = data.distributorInfo
          this.tradeInfo = data.tradeInfo
          // this.refund_fee = this.orderInfo.items[0].total_fee / 100
          //  退款金额为订单总金额，以前为商品单个金额 2020-10-26
          this.refund_fee = this.orderInfo.total_fee / 100
          this.refund_point = this.orderInfo.items[0].point
          if(data.refundInfo) {
            this.refundInfo = data.refundInfo
          }
          if(data.aftersales.sendback_data.length == 0) {
            this.aftersalesInfo.sendback_data = null
          }
          if(data.aftersales.sendconfirm_data.length == 0) {
            this.aftersalesInfo.sendconfirm_data = null
          }
          this.loading = false
        })
      },
      reviewSubmit () {
        this.reviewData.aftersales_bn = this.aftersales_bn
        this.reviewData.is_approved = this.is_approved
        if(this.is_approved == 1) {
          if(this.refund_fee <=0 && this.refund_point <=0) {
            this.$message.error('退款金额必填！')
          }else if(this.refund_fee > this.orderInfo.total_fee) {
            this.$message.error('退款金额不能大于订单金额！')
          }
          this.reviewData.refund_fee = this.refund_fee * 100
          this.reviewData.refund_point = this.refund_point
          reviewAftersales(this.reviewData).then(response => {
              if(response.data.data) {
                  this.$message({
                      message: '退款审核成功！',
                      type: 'success'
                  });
                  this.aftersaleInfo()
              } else {
                  this.$message.error('退款审核失败')
                  return false
              }
          })
        } else {
          if(this.refuse_reason) {
            this.reviewData.refuse_reason = this.refuse_reason
          } else {
            this.$message.error('拒绝原因必填！')
          }
          reviewAftersales(this.reviewData).then(response => {
              if(response.data.data) {
                  this.$message({
                      message: '退款驳回成功！',
                      type: 'success'
                  });
                  this.aftersaleInfo()
              } else {
                  this.$message.error('退款驳回失败')
                  return false
              }
          })
        }
      },
      sendBackAction() {
        this.exchangeSendBack.aftersales_bn = this.aftersales_bn
        this.exchangeSendBack.corp_code = this.corp_code
        this.exchangeSendBack.logi_no = this.logi_no
        sendConfirm(this.reviewData).then(response => {
          if(response.data.data) {
            this.$message({
              message: '重新发货成功！',
              type: 'success'
            });
            this.aftersaleInfo()
          } else {
            this.$message.error('重新发货失败！')
            return false
          }
        })
      },
      refundAction() {
        this.refundData.aftersales_bn = this.aftersales_bn
        this.refundData.check_refund = this.check_refund
        this.refundData.refund_memo = this.refuse_reason
        this.refundData.refund_fee = this.refund_fee * 100
        this.refundData.refund_point = this.refund_point
        if(this.refundData.check_refund == "0" && !this.refundData.refund_memo) {
          this.$message.error('拒绝原因必填！')
        }
        if(this.refundData.check_refund == "1" && (!this.refundData.refund_fee)) {
          this.$message.error('退款金额必填！')
        }
        refundCheck(this.refundData).then(response => {
          if(response.data.data) {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
            this.aftersaleInfo()
          } else {
            this.$message.error('操作失败！')
            return false
          }
        })
      },
           getStatus () {
            isBind().then(response => {
              this.IsBind = response.data.data.result
            })
      },
    },
    mounted () {
      if (this.$route.query.aftersales_bn) {
        this.aftersales_bn = this.$route.query.aftersales_bn
      }
      this.loading = true
      this.getStatus()
      this.aftersaleInfo()

    }
  }
</script>



// WEBPACK FOOTER //
// detail.vue?12c6767f